const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

const { InspectorControls } = wp.blockEditor;

const { ToggleControl, PanelBody, Disabled } = wp.components;
const { serverSideRender: ServerSideRender } = wp;

import icons from "../../../icons.js";
/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType("wp-apidae/moyens-communication", {
	title: __("Moyens de communication", "wp-apidae"), // Block title.
	description: __("Affiche les moyens de communication.", "wp-apidae"),
	icon: {
		foreground: "#EFB114",
		background: "#331F5B",
		src: icons.email,
	},
	supports: {
		align: ["full", "wide"],
	},
	example: {},
	attributes: {
		telephone: {
			type: "boolean",
			default: true,
		},
		fax: {
			type: "boolean",
			default: true,
		},
		mel: {
			type: "boolean",
			default: true,
		},
		site_web_url: {
			type: "boolean",
			default: true,
		},
		facebook: {
			type: "boolean",
			default: true,
		},
		twitter: {
			type: "boolean",
			default: true,
		},
		tripadvisor: {
			type: "boolean",
			default: true,
		},
		instagram: {
			type: "boolean",
			default: true,
		},
		chaine_youtube: {
			type: "boolean",
			default: true,
		},
		chaine_dailymotion: {
			type: "boolean",
			default: true,
		},
		chaine_vimeo: {
			type: "boolean",
			default: true,
		},
		galerie_flickr: {
			type: "boolean",
			default: true,
		},
		pinterest: {
			type: "boolean",
			default: true,
		},
		snapchat: {
			type: "boolean",
			default: true,
		},
		tiktok: {
			type: "boolean",
			default: true,
		},
		show_labels: {
			type: "boolean",
			default: true,
		},
		align: {
			type: "string",
			default: "",
		},
	},
	edit: class extends wp.element.Component {
		render() {
			const props = this.props;
			const attributes = props.attributes;

			var template = window.WpApidaeTemplateData.settings;

			return [
				<InspectorControls key={"inspector"}>
					<PanelBody title={__("Champs")}>
						<ToggleControl
							label={__("Téléphone")}
							checked={attributes.telephone}
							onChange={() => {
								props.setAttributes({ telephone: !attributes.telephone });
							}}
						/>
						<ToggleControl
							label={__("Fax")}
							checked={attributes.fax}
							onChange={() => {
								props.setAttributes({ fax: !attributes.fax });
							}}
						/>
						<ToggleControl
							label={__("Mel")}
							checked={attributes.mel}
							onChange={() => {
								props.setAttributes({ mel: !attributes.mel });
							}}
						/>
						<ToggleControl
							label={__("Site Web")}
							checked={attributes.site_web_url}
							onChange={() => {
								props.setAttributes({ site_web_url: !attributes.site_web_url });
							}}
						/>
						<ToggleControl
							label={__("Facebook")}
							checked={attributes.facebook}
							onChange={() => {
								props.setAttributes({ facebook: !attributes.facebook });
							}}
						/>
						<ToggleControl
							label={__("Twitter")}
							checked={attributes.twitter}
							onChange={() => {
								props.setAttributes({ twitter: !attributes.twitter });
							}}
						/>
						<ToggleControl
							label={__("Tripadvisor")}
							checked={attributes.tripadvisor}
							onChange={() => {
								props.setAttributes({ tripadvisor: !attributes.tripadvisor });
							}}
						/>
						<ToggleControl
							label={__("Instagram")}
							checked={attributes.instagram}
							onChange={() => {
								props.setAttributes({ instagram: !attributes.instagram });
							}}
						/>
						<ToggleControl
							label={__("Chaine Youtube")}
							checked={attributes.chaine_youtube}
							onChange={() => {
								props.setAttributes({
									chaine_youtube: !attributes.chaine_youtube,
								});
							}}
						/>
						<ToggleControl
							label={__("Chaine Dailymotion")}
							checked={attributes.chaine_dailymotion}
							onChange={() => {
								props.setAttributes({
									chaine_dailymotion: !attributes.chaine_dailymotion,
								});
							}}
						/>
						<ToggleControl
							label={__("Chaine Vimeo")}
							checked={attributes.chaine_vimeo}
							onChange={() => {
								props.setAttributes({ chaine_vimeo: !attributes.chaine_vimeo });
							}}
						/>
						<ToggleControl
							label={__("Galerie Flickr")}
							checked={attributes.galerie_flickr}
							onChange={() => {
								props.setAttributes({
									galerie_flickr: !attributes.galerie_flickr,
								});
							}}
						/>
						<ToggleControl
							label={__("Tableau Pinterest")}
							checked={attributes.pinterest}
							onChange={() => {
								props.setAttributes({ pinterest: !attributes.pinterest });
							}}
						/>
						<ToggleControl
							label={__("Snapchat")}
							checked={attributes.snapchat}
							onChange={() => {
								props.setAttributes({ snapchat: !attributes.snapchat });
							}}
						/>
						<ToggleControl
							label={__("TikTok")}
							checked={attributes.tiktok}
							onChange={() => {
								props.setAttributes({ tiktok: !attributes.tiktok });
							}}
						/>
					</PanelBody>
					<PanelBody title={__("Options")}>
						<ToggleControl
							label={__("Afficher les titres")}
							checked={attributes.show_labels}
							onChange={() => {
								props.setAttributes({ show_labels: !attributes.show_labels });
							}}
						/>
					</PanelBody>
				</InspectorControls>,
				<Disabled>
					<ServerSideRender
						block="wp-apidae/moyens-communication"
						attributes={attributes}
						urlQueryArgs={{
							settings: template,
						}}
					/>
				</Disabled>,
			];
		}
	},

	save: () => {
		return null;
	},
});
